import React from "react";
import ModalConfirm from "./ModalConfirm";


const ModalError = ({ title = "Error", errorMessage, forSupport, ...props }) => {
    return (
        <ModalConfirm
            zindex={99999}
            confirmButtonTitle="Okay"
            onConfirm={props.onClose}
            title={title}
            description={`${errorMessage}<br /><br />Message for Support:<br /><em>${forSupport}</em>`}
            {...props}
        />
    );
};

export default ModalError;
